import React from 'react';
import { Target, Flag, Megaphone } from 'lucide-react';
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TARGET_AUDIENCES, CONTENT_GOALS, CTA_TYPES, COMPETITOR_ANGLES } from "../../../convex/posts";

interface MarketingOptionsProps {
  register: any;
  isMarketerMode: boolean;
}

export default function MarketingOptions({ register, isMarketerMode }: MarketingOptionsProps) {
  return (
    <div className="space-y-6 bg-gray-50 p-6 rounded-lg border border-gray-200">
      <div className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Megaphone className="w-5 h-5 text-blue-600" />
        Marketing Options
      </div>

      <div>
        <Label className="flex items-center gap-2">
          <Target className="w-4 h-4" />
          Target Audience
        </Label>
        <Select defaultValue="b2b" onValueChange={(value) => register('targetAudience').onChange({ target: { value } })}>
          <SelectTrigger>
            <SelectValue placeholder="Select target audience" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(TARGET_AUDIENCES).map(([value, label]) => (
              <SelectItem key={value} value={value}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="flex items-center gap-2">
          <Flag className="w-4 h-4" />
          Content Goal
        </Label>
        <Select defaultValue="awareness" onValueChange={(value) => register('contentGoal').onChange({ target: { value } })}>
          <SelectTrigger>
            <SelectValue placeholder="Select content goal" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(CONTENT_GOALS).map(([value, label]) => (
              <SelectItem key={value} value={value}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label>Call-to-Action Type</Label>
        <Select defaultValue="soft" onValueChange={(value) => register('ctaType').onChange({ target: { value } })}>
          <SelectTrigger>
            <SelectValue placeholder="Select CTA type" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(CTA_TYPES).map(([value, label]) => (
              <SelectItem key={value} value={value}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label>Competitor Angle</Label>
        <Select defaultValue="direct" onValueChange={(value) => register('competitorAngle').onChange({ target: { value } })}>
          <SelectTrigger>
            <SelectValue placeholder="Select competitor angle" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(COMPETITOR_ANGLES).map(([value, label]) => (
              <SelectItem key={value} value={value}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}